// Die Anliegen-Reihe ist ein Swiper (Web Component). Die Pfeile stehen unter der
// Reihe, also ausserhalb des Elements — Swipers eigene Navigation liegt im
// Shadow DOM und wäre nicht zu gestalten. Dieses Modul verbindet beide und führt
// den Zustand der Knöpfe nach.
//
// Bewusst kein Vue, wie beim Rücksprung nach oben: keine Reaktivität nötig, und
// ein Renderfehler in der In-DOM-Kompilierung würde die ganze Seite verwerfen.
// Dafür muss init() NACH app.mount() laufen — dort ruft main.js register(), und
// erst damit wird aus <swiper-container> ein Element mit `.swiper`.

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

// Swiper animiert den Wechsel; ohne Bewegungswunsch springt die Reihe. Die Dauer
// wird je Klick übergeben, damit eine Änderung der Einstellung sofort greift.
function speed(swiper) {
    return window.matchMedia(REDUCED_MOTION).matches ? 0 : swiper.params.speed;
}

function wire(element) {
    // Das Upgrade des Custom Elements hängt an der Reaktionswarteschlange des
    // Browsers und kann nach diesem Aufruf liegen; dann gibt es noch keine
    // Instanz. Der Rückweg ist Swipers eigenes init-Ereignis.
    if (!element.swiper) {
        element.addEventListener("swiperinit", () => wire(element), { once: true });
        return;
    }

    const swiper = element.swiper;
    const section = element.closest(".section");
    const prev = section?.querySelector("[data-card-grid-prev]");
    const next = section?.querySelector("[data-card-grid-next]");
    if (!prev || !next) return;

    const update = () => {
        // isLocked: alle Karten sind im Bild, es gibt nichts zu blättern.
        section.classList.toggle("section-card-grid--locked", swiper.isLocked);
        prev.setAttribute("aria-disabled", String(swiper.isBeginning));
        next.setAttribute("aria-disabled", String(swiper.isEnd));
    };

    const step = (button, move) => {
        button.addEventListener("click", () => {
            if (button.getAttribute("aria-disabled") === "true") return;
            move(speed(swiper));
        });
    };

    step(prev, (ms) => swiper.slidePrev(ms));
    step(next, (ms) => swiper.slideNext(ms));

    // Der CTA jeder Karte ist ein Link. Tabbt man auf eine Karte ausserhalb des
    // Bildes, scrollt der Browser sie nicht heran — Swiper verschiebt die Reihe
    // per transform statt zu scrollen. Also selbst nachführen.
    element.addEventListener("focusin", (event) => {
        const slide = event.target.closest("swiper-slide");
        if (!slide || slide.classList.contains("swiper-slide-visible")) return;

        const index = swiper.slides.indexOf(slide);
        if (index >= 0) swiper.slideTo(index, speed(swiper));
    });

    // progress deckt jede Bewegung ab, lock/unlock den Wechsel der Fensterbreite.
    swiper.on("progress lock unlock", update);
    update();
}

export function initCardGridSlider(root = document) {
    root.querySelectorAll(".section-card-grid__cards").forEach(wire);
}
